<div *ngIf="aberta" class="modal-backdrop-custom" (click)="fechar.emit()">
  <div class="modal-card modal-historico-folha" (click)="$event.stopPropagation()">
    <div class="modal-header-custom">
      <h3 class="h5 mb-0">{{ titulo }}</h3>
      <button type="button" class="btn btn-light btn-sm" (click)="fechar.emit()" aria-label="Fechar">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body-custom">
      <div *ngIf="carregando" class="text-secondary">Carregando historico...</div>
      <p *ngIf="!carregando && erro" class="text-danger mb-0">{{ erro }}</p>
      <p *ngIf="!carregando && !erro && alteracoes.length === 0" class="text-secondary mb-0">
        Nenhuma alteracao de batida registrada para este dia.
      </p>
      <div class="table-responsive" *ngIf="!carregando && alteracoes.length > 0">
        <table class="table table-sm align-middle">
          <thead>
            <tr>
              <th>Quando</th>
              <th>Batida</th>
              <th>Operacao</th>
              <th>Antes</th>
              <th>Depois</th>
              <th>Usuario</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of alteracoes">
              <td class="text-nowrap">{{ item.criadoEm | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ item.numeroBatida }}a</td>
              <td>{{ rotuloOperacao(item.operacao) }}</td>
              <td>
                {{ item.dataHoraAnterior ? (item.dataHoraAnterior | date:'HH:mm':'America/Sao_Paulo') : 'vazio' }}
                <span *ngIf="item.nsrAnterior"> (NSR {{ item.nsrAnterior }})</span>
                <span *ngIf="item.tinhaCapturaFacial && item.operacao === 'EXCLUSAO'">, com captura</span>
              </td>
              <td>
                {{ item.dataHoraNova ? (item.dataHoraNova | date:'HH:mm':'America/Sao_Paulo') : 'vazio' }}
                <span *ngIf="item.nsrNovo"> (NSR {{ item.nsrNovo }})</span>
              </td>
              <td>{{ item.usuarioNome || item.origem || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
